document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".footer-menu-item-heading");

  navItems.forEach((item) => {
    item.addEventListener("click", (el) => {
      const nextSibling = item.nextElementSibling;
      const arrowhead = item.querySelector("svg");

      if (item.classList.contains("active")) {
        item.classList.remove("active");
        arrowhead.classList.remove("active");
        nextSibling.style.display = "none";
      } else {
        item.classList.add("active");
        arrowhead.classList.add("active");
        nextSibling.style.display = "block";
      }
    });
  });

  const backTopButton = document.getElementById("back-top-button");

  window.addEventListener("scroll", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 500) {
      backTopButton.classList.add("show");
    } else {
      backTopButton.classList.remove("show");
    }
  });

  backTopButton.addEventListener("click", (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
